import React from 'react'
import { ATLIconizedText } from '@appsimples/atlantica-react-native'
import { atlTheme } from '../../../atlTheme'
import { ImageSourcePropType } from 'react-native'

export interface CustomATLIconizedTextProps {
  icon: ImageSourcePropType
  text: string
  textColor?: any
}
export const CustomATLIconizedText: React.FunctionComponent<CustomATLIconizedTextProps> = ({
  icon,
  text,
  textColor,
}) => {
  return (
    <ATLIconizedText
      icon={icon}
      text={text}
      labelBaseProps={textColor ? { multilineLimit: 2, textColor: textColor } : { multilineLimit: 2 }}
      iconBaseProps={{ tintColor: atlTheme.ColorBrand2Default }}
    />
  )
}
